import './bootstrap';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import 'flowbite';
import vClickOutside from './directives/v-click-outside';
import Toast, { POSITION } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import VueTheMask from '@rj-pkgs/vue-the-mask'

// axios.defaults.baseURL = 'https://test.unac.asso.fr/api/v1/';
axios.defaults.baseURL = 'https://unac.asso.fr/api/v1/';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'application/json';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.directive('click-outside', vClickOutside);
app.use(VueTheMask)
app.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 4000,
  closeOnClick: true,
  pauseOnHover: true,
});

// Mount app
app.mount('#vue-app');
